import { useUIStore } from "@/stores";
import { Box, Button, Stack, TextField } from "@mui/material";
import { FC, FormEvent, useState } from "react";
import { useCancelEvent } from "../../queries";
import { CancelEventProps } from "./cancel-event.types";

const CancelEvent: FC<CancelEventProps> = ({ eventId }) => {
  const { closeModal } = useUIStore();
  const { cancelEvent, isCancelEventLoading } = useCancelEvent();

  const [cancellationReason, setCancellationReason] = useState("");

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    cancelEvent({
      eventId,
      cancellationReason,
    });
  };

  return (
    <Box component="form" onSubmit={onSubmit}>
      <TextField
        multiline
        label="Reason"
        slotProps={{ htmlInput: { maxLength: 500 } }}
        minRows={5}
        value={cancellationReason}
        onChange={({ target: { value } }) => setCancellationReason(value)}
      />

      <Stack direction={"row"} spacing={2} mt={2}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          disabled={isCancelEventLoading}
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          type="submit"
          loading={isCancelEventLoading}
          disabled={!cancellationReason || isCancelEventLoading}
        >
          Confirm
        </Button>
      </Stack>
    </Box>
  );
};

export { CancelEvent };
